import React from 'react';
import Botao from '../primitivos/Botao';
import Icone from '../primitivos/Icone';

/**
 * Falha ao carregar uma lista, com saída (at-56, frente B).
 *
 * 🔴 **Existe porque a falha era MUDA.** Em `/adesoes` o erro da listagem caía
 * num `console.error` e a lista ficava vazia — indistinguível de "você não tem
 * cadastros". A spec 02 §2.7 e §9 exigem o contrário: *"nenhuma falha pode ficar
 * silenciosa (regra do projeto: spinner eterno e falha muda são o mesmo
 * defeito)"*, e o erro precisa **oferecer tentar de novo**.
 *
 * ⚠️ `role="alert"` para o leitor de tela anunciar sem o usuário ir procurar.
 *
 * ⚠️ **Não use para pendência de negócio.** Vermelho aqui significa "a tela não
 * conseguiu carregar". Registro que ainda não subiu ao SGA é `Chip pendente`
 * (âmbar) — a spec 02 §2.3 é explícita em não fazer pendência parecer alarme.
 */

interface PropsErrorState {
  /** O que falhou, em linguagem de usuário. */
  mensagem: string;
  /** Detalhe técnico ou do backend, quando ajudar. Opcional. */
  detalhe?: string;
  aoTentarNovamente?: () => void;
  /** Trava o botão enquanto a nova tentativa corre. */
  ocupado?: boolean;
}

const ErrorState: React.FC<PropsErrorState> = ({
  mensagem,
  detalhe,
  aoTentarNovamente,
  ocupado = false,
}) => (
  <div
    className="tw-flex tw-flex-col tw-items-center tw-gap-2 tw-rounded-xl tw-border tw-border-danger/20 tw-bg-danger-bg tw-px-6 tw-py-12 tw-text-center"
    role="alert"
  >
    <span className="tw-text-danger" aria-hidden="true">
      <Icone nome="alerta" tamanho={28} />
    </span>
    <p className="tw-m-0 tw-font-marca tw-text-sm tw-font-bold tw-text-danger">{mensagem}</p>
    {detalhe && <p className="tw-m-0 tw-text-xs tw-text-texto-suave">{detalhe}</p>}
    {aoTentarNovamente && (
      <Botao
        variante="primario"
        tamanho="sm"
        iconeEsquerda="recarregar"
        carregando={ocupado}
        onClick={aoTentarNovamente}
        className="tw-mt-2"
      >
        Tentar novamente
      </Botao>
    )}
  </div>
);

export default ErrorState;
